/**
 * Returns the top and left coordinates of an element relative to the document.
 * Use this function get the position to scroll to an element.
 * @param {HTMLElement} element The HTMLElement to check.
 * @returns {(object|null)} An object with top and left coordinates or null if the element is not an HTMLElement instance.
 */
export default function getPositionOfElement(element) {
    if (!(element instanceof HTMLElement)) {
        return null
    }

    const bounds = element.getBoundingClientRect()
    const scrollTop = document.scrollingElement.scrollTop
    const scrollLeft = document.scrollingElement.scrollLeft

    const clientTop = document.documentElement.clientTop
    const clientLeft = document.documentElement.clientLeft

    const top = bounds.top + scrollTop - clientTop
    const left = bounds.left + scrollLeft - clientLeft

    return { top: Math.round(top), left: Math.round(left) }
}



// WEBPACK FOOTER //
// ./scripts/util/getPositionOfElement.js